import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

export default {
  'de-DE': { APP: de },
  'el-GR': { APP: el },
  'en-US': { APP: en },
  'es-ES': { APP: es },
  'fi-FI': { APP: fi },
  'fr-FR': { APP: fr },
  'it-IT': { APP: it },
  'pl-PL': { APP: pl },
  'pt-PT': { APP: pt }
};
